import { enumProductServiceType } from '@app/data-layer/enums/common/enumProductServiceType';
import { enumBillItemProductCode } from '@app/data-layer/enums/payments';

export const BILL_SERVICE_PRODUCT_CODES = {
  [enumProductServiceType.PLAN]: [
    enumBillItemProductCode.STARTERPLN,
    enumBillItemProductCode.GROWTHPLN,
    enumBillItemProductCode.ENTERPRISEPLN,
  ],
  [enumProductServiceType.CUSTOMS_BONDS]: [enumBillItemProductCode.CONTINUOUS_ANNUAL_BOND],
  [enumProductServiceType.ISF]: [enumBillItemProductCode.ISF, enumBillItemProductCode.ISF_SINGLE_BOND],
  [enumProductServiceType.MARINE_INSURANCE]: [
    enumBillItemProductCode.MARINE_INSURANCE,
    enumBillItemProductCode.MARINE_INSURANCE_PROCESSING,
    enumBillItemProductCode.MARINE_INSURANCE_DIFFERENCE,
    enumBillItemProductCode.MARINE_INSURANCE_PROCESSING_DIFFERENCE,
  ],
  [enumProductServiceType.INTERNATIONAL_SHIPPING]: [
    enumBillItemProductCode.ORIGIN_CBM,
    enumBillItemProductCode.ORIGIN_HBL,
    enumBillItemProductCode.FREIGHT,
    enumBillItemProductCode.DESTINATION_CBM,
    enumBillItemProductCode.DESTINATION_HBL,
    enumBillItemProductCode.ADDITIONAL_CHARGES,
    enumBillItemProductCode.EXPORT_LICENSE,
    enumBillItemProductCode.LOADING_FEES,
    enumBillItemProductCode.UNLOADING_FEES,
  ],
  [enumProductServiceType.ENTRY_SUMMARY]: [
    enumBillItemProductCode.BROKER_ENTRY,
    enumBillItemProductCode.TRUCKER_BROKER_ENTRY,
    // Deposit codes retained only for historical bills; deposit feature is removed.
    enumBillItemProductCode.TRUCKER_DEPOSIT,
    enumBillItemProductCode.DEPOSIT_SETTLEMENT,
    enumBillItemProductCode.DEPOSIT_DIFFERENCE,
    enumBillItemProductCode.SELF_ENTRY,
    enumBillItemProductCode.ES_SINGLE_BOND,
    enumBillItemProductCode.OTHER_PGA,
    enumBillItemProductCode.ES_DUTIES,
    enumBillItemProductCode.ADDITION_TO_ENTRY_BOND,
    enumBillItemProductCode.ADDITIONAL_INVOICES,
    enumBillItemProductCode.ADDITIONAL_LINES,
    enumBillItemProductCode.FWS,
    enumBillItemProductCode.OTHER_ADDITIONAL_PAYMENT,
    enumBillItemProductCode.ADDITIONAL_CUSTOMS_DUTIES,
    enumBillItemProductCode.ADDITIONAL_ENTRY_HANDLING,
  ],
  [enumProductServiceType.ASSIGNED_CBP_NUMBER_REQUEST]: [
    enumBillItemProductCode.ASSIGNED_CBP_NUMBER_REQUEST,
    enumBillItemProductCode.ASSIGNED_CBP_NUMBER_REQUEST_1,
    enumBillItemProductCode.ASSIGNED_CBP_NUMBER_REQUEST_2,
  ],
};
